define('lib/layer-selector/components/added-layers-container',['lib/layer-selector/layer-selector-helpers'], function(LayerSelectorHelpers) {
  /**
   * Creates a HTMLElement container with all the added layers as child elements
   * @param {*} layers
   * @param {*} parentContext
   */
  return function(layers, parentContext) {
    var addedLayersContainer = LayerSelectorHelpers.createDomElement('div', {
      id: 'ls-added-layers-container',
      cssClass: 'ls__added-layers-container',
    });
    layers.forEach(
      function(layer, index) {
        var layerEl = LayerSelectorHelpers.createDomElement('div', {
          id: 'added-layer-' + index,
          cssClass: 'ls__added-layer',
          content: '<span>' + layer.title + '</span>',
        });
        var sortIconEl = LayerSelectorHelpers.createDomElement('div', {
          cssClass: 'ls__added-layer-sort',
          content: '<i class="fas fa-sort"></i>',
          title: 'Ändra ordning (drag och släpp)',
        });
        var buttonContainerEl = LayerSelectorHelpers.createDomElement('div', {
          cssClass: 'ls__added-layer-button-container',
        });
        var infoButtonEl = LayerSelectorHelpers.createDomElement('i', {
          cssClass: 'ls__added-layer-info fas fa-info-circle ls__cursor-pointer',
          title: 'Information',
          clickCallback: this.showLayerInfo.bind(this, layer, index),
        });
        var deleteButtonEl = LayerSelectorHelpers.createDomElement('i', {
          cssClass: 'ls__added-layer-delete fas fa-trash ls__cursor-pointer',
          title: 'Ta bort',
          clickCallback: this.deleteAddedLayer.bind(this, layer, index),
        });
        var editButtonEl = LayerSelectorHelpers.createDomElement('i', {
          cssClass: 'ls__added-layer-delete fas fa-cog ls__cursor-pointer',
          title: 'Lageralternativ',
          clickCallback: this.toggleLayerStyles.bind(this, layer, index),
        });
        buttonContainerEl.appendChild(infoButtonEl);
        buttonContainerEl.appendChild(editButtonEl);
        buttonContainerEl.appendChild(deleteButtonEl);

        var styleContainerEl = LayerSelectorHelpers.createDomElement('div', {
          id: 'added-layer-styles-' + index,
          cssClass: 'ls__style-container',
        });

        // add close button
        var styleContainerCloseButtonEl = LayerSelectorHelpers.createDomElement('i', {
          cssClass: 'ls__style-close fas fa-times ls__cursor-pointer',
          clickCallback: this.hideLayerStyles.bind(this, layer, index),
        });
        styleContainerEl.appendChild(styleContainerCloseButtonEl);

        // add opacity slider
        var opacitySliderContainerEl = LayerSelectorHelpers.createDomElement('div', {
          cssClass: 'ls__opacity-slider-container',
          content: '<i class="fas fa-adjust"></i>',
        });
        var opacitySliderEl = LayerSelectorHelpers.createDomElement('input', {
          cssClass: 'ls__opacity-slider',
          attributes: {
            type: 'range',
            min: 0,
            max: 100,
            value: 100,
          },
        });
        LayerSelectorHelpers.addEventListeners({
          elements: [opacitySliderEl],
          events: ['input', 'change'],
          callback: function(e) {
            e.preventDefault();
            var layerOpacity = e.target.value / 100;
            layer.wmsLayer.setOpacity(layerOpacity);
          }.bind(parentContext),
        });
        LayerSelectorHelpers.addEventListeners({
          elements: [opacitySliderEl],
          events: ['mouseenter'],
          callback: function(e) {
            this.disableMapScroll();
            this.disableMapPan();
          }.bind(parentContext),
        });
        opacitySliderContainerEl.appendChild(opacitySliderEl);

        // add layer style select
        // comment for now, no support for layer styles yet
        // var styleDropdownContainerEl = LayerSelectorHelpers.createDomElement('div', {
        //   id: 'style-dropdown-' + index,
        //   cssClass: 'ls__style-dropdown-container',
        // });
        // var styleDropdownEl = LayerSelectorHelpers.createDomElement('select', {
        //   cssClass: 'ls__style-dropdown',
        //   content: '<option>Välj lagerstil</option><option>Testar en stil</option>',
        // });
        // LayerSelectorHelpers.addEventListeners({
        //   elements: [styleDropdownEl],
        //   events: ['change'],
        //   callback: function(e) {
        //     e.preventDefault();
        //     console.log('dropdown change', e.target.value);
        //   }.bind(parentContext),
        // });
        // styleDropdownContainerEl.appendChild(styleDropdownEl);

        styleContainerEl.appendChild(opacitySliderContainerEl);
        //styleContainerEl.appendChild(styleDropdownContainerEl);
        layerEl.appendChild(sortIconEl);
        layerEl.appendChild(buttonContainerEl);
        layerEl.appendChild(styleContainerEl);
        addedLayersContainer.appendChild(layerEl);
      }.bind(parentContext)
    );

    return addedLayersContainer;
  };
});

